import type { XlsxTemplate } from '../../../../common/interfaces/xlsx-section';

export const POINTS_OF_INTEREST_XLSX_TEMPLATE: XlsxTemplate = [
  {
    name: 'forms.information.pointsOfInterestHeading',
    fields: [
      {
        key: 'address',
        name: 'labels.address',
        required: true,
      },
      {
        key: 'name',
        name: 'forms.information.pointName',
        required: true,
      },
    ],
    required: true,
  },
  {
    name: 'labels.openingHours',
    fields: [
      {
        key: 'weekdayFrom',
        name: (translateService) =>
          `${translateService.instant('labels.weekday')} (${translateService.instant('labels.from').toLowerCase()})`,
        required: true,
      },
      {
        key: 'weekdayTo',
        name: (translateService) =>
          `${translateService.instant('labels.weekday')} (${translateService.instant('labels.to').toLowerCase()})`,
        required: true,
      },
      {
        key: 'saturdayFrom',
        name: (translateService) =>
          `${translateService.instant('labels.saturday')} (${translateService.instant('labels.from').toLowerCase()})`,
      },
      {
        key: 'saturdayTo',
        name: (translateService) =>
          `${translateService.instant('labels.saturday')} (${translateService.instant('labels.to').toLowerCase()})`,
      },
      {
        key: 'sundayFrom',
        name: (translateService) =>
          `${translateService.instant('labels.sunday')} (${translateService.instant('labels.from').toLowerCase()})`,
      },
      {
        key: 'sundayTo',
        name: (translateService) =>
          `${translateService.instant('labels.sunday')} (${translateService.instant('labels.to').toLowerCase()})`,
      },
    ],
    required: true,
  },
  {
    name: 'pointsOfInterest.times.heading',
    fields: [
      {
        key: 'averageServiceTime',
        name: 'labels.averageServiceTime',
        required: true,
      },
    ],
    required: true,
  },
  {
    name: 'forms.phone.heading',
    fields: [
      {
        key: 'phone',
        name: 'labels.storagePhone',
      },
    ],
  },
  {
    name: 'pointsOfInterest.contractors.assignedContractors',
    fields: [
      {
        key: 'contractors',
        name: 'contractors.contractors',
      },
    ],
  },
  {
    name: 'labels.note',
    fields: [
      {
        key: 'note',
        name: 'labels.note',
      },
    ],
  },
] as const;
